import { PriceStrategySnapWorkOrder } from '@snap-types/transforms/price-strategy/shared';

import { QuoteBuilderOperationType } from '../../types/state/operation';
import { QuoteBuilderRequirementType } from '../../types/state/requirement';
import { transformSnapRequirementToStoreState } from './transform-requirement';

export function transformSnapOperationToStoreState(
  operation: PriceStrategySnapWorkOrder['snapOperations'][number],
): { uuid: string; operation: QuoteBuilderOperationType } {
  const requirementUuids: string[] = [];
  const snapRequirements: Record<string, QuoteBuilderRequirementType> = {};

  for (const snapRequirement of operation.snapRequirements) {
    const { uuid, requirement } =
      transformSnapRequirementToStoreState(snapRequirement);
    requirementUuids.push(uuid);
    snapRequirements[uuid] = requirement;
  }

  return {
    uuid: operation.uuid,
    operation: {
      uuid: operation.uuid,
      sequenceNo: operation.sequenceNo,
      resourceId: operation.resourceId,
      notes: operation.notes ?? null,
      runType: operation.runType,
      run: operation.run ?? null,
      loadSizeQty: operation.loadSizeQty ?? null,
      setupCostPerHr: operation.setupCostPerHr ?? null,
      runCostPerHr: operation.runCostPerHr ?? null,
      runCostPerUnit: operation.runCostPerUnit ?? null,
      serviceBaseCharge: operation.serviceBaseCharge ?? null,
      serviceMinCharge: operation.serviceMinCharge ?? null,
      serviceChargePerUnit: operation.serviceChargePerUnit ?? null,
      burPerHrSetup: operation.burPerHrSetup ?? null,
      burPerHrRun: operation.burPerHrRun ?? null,
      burPerUnitRun: operation.burPerUnitRun ?? null,
      burPerOperation: operation.burPerOperation,
      setupHrs: operation.setupHrs ?? null,
      serviceId: operation.serviceId ?? null,
      burPercentRun: operation.burPercentRun ?? null,
      burPercentSetup: operation.burPercentSetup ?? null,
      scrapYieldPct: operation.scrapYieldPct ?? null,
      fixedScrapUnits: operation.fixedScrapUnits ?? null,
      scrapYieldType: operation.scrapYieldType,

      documents: operation.documents,

      snapRequirementUuids: requirementUuids,
      snapRequirements,
    },
  };
}
